import React, { useState, useEffect } from "react";
import { X } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function NewsletterPopup() {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (localStorage.getItem("ck_newsletter_seen")) return;
    let done = false;
    const reveal = () => { if (!done) { done = true; setShow(true); } };
    // Appear after a longer delay so it never interrupts early browsing…
    const t = setTimeout(reveal, 25000);
    // …or when the visitor moves to leave the page (exit intent).
    const onLeave = (e) => { if (e.clientY <= 0) reveal(); };
    document.addEventListener("mouseleave", onLeave);
    return () => { clearTimeout(t); document.removeEventListener("mouseleave", onLeave); };
  }, []);

  const close = () => { localStorage.setItem("ck_newsletter_seen", "1"); setShow(false); };
  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/newsletter", { email }); toast.success("You're in! Check your inbox for your 10% off code."); close(); }
    catch { toast.error("Please enter a valid email."); }
  };

  if (!show) return null;
  return (
    <div className="fixed bottom-4 right-4 left-4 sm:left-auto z-[70] w-auto sm:w-[360px] ck-fade-up" data-testid="newsletter-popup">
      <div className="bg-white rounded-sm shadow-2xl border border-brand-border overflow-hidden relative">
        <button onClick={close} className="absolute top-2.5 right-2.5 text-muted-foreground hover:text-brand-ink z-10" data-testid="newsletter-close" aria-label="Close"><X className="w-5 h-5" /></button>
        <div className="h-24 bg-cover bg-center" style={{ backgroundImage: "url(https://images.unsplash.com/photo-1668072587859-f0f30c8fa938?crop=entropy&cs=srgb&fm=jpg&q=85&w=600)" }} />
        <div className="p-5">
          <p className="text-xs uppercase tracking-luxe text-brand-pink mb-1.5">Join the list</p>
          <h3 className="font-serif-display text-2xl leading-tight mb-2">Get 10% off your first order</h3>
          <p className="text-sm text-muted-foreground mb-4">Be first to see new makes and little treats — straight to your inbox.</p>
          <form onSubmit={submit} className="space-y-2.5">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email address"
              className="w-full border border-brand-border rounded-sm px-3 py-2.5 text-sm outline-none focus:border-brand-pink" data-testid="newsletter-email" />
            <button className="w-full bg-brand-ink text-white py-2.5 rounded-sm text-sm hover:bg-brand-pink hover:text-brand-ink transition-colors" data-testid="newsletter-submit">Sign me up</button>
          </form>
        </div>
      </div>
    </div>
  );
}
